import type { GenderEnum } from '@halo/chat-sdk-react';

export interface UserLoginCodeResponse {
  code: string;
  ip: string;
  now_time: number;
  expire_time: number;
  country: string;
  province: string;
  city: string;
}

export interface UserLoginWaitCodeResponse {
  content: string;
  user_id: string;
  name: string;
  avatar: string;
  token: string;
  username: string;
  have_user_key: boolean;
  have_group_key: boolean;
  first_name: string;
  last_name: string;
  avatar_color: string;
  expire_time: number;
  server_time: number;
}

export interface UserLoginResponse {
  avatar_color: string;
  expire_time: number;
  first_name: string;
  have_group_key: boolean;
  have_user_key: boolean;
  last_name: string;
  name: string;
  server_time: number;
  token: string;
  id_token: string;
  user_id: string;
  username: string;
  is_new_user: boolean;
}

export interface UserInfoResponse {
  avatar: string;
  avatar_color: string;
  city: string;
  country: string;
  first_name: string;
  ip: string;
  last_name: string;
  name: string;
  province: string;
  register_time: number;
  user_id: string;
  username: string;
  username_a: string;
  gender?: GenderEnum;
  birthday?: number | string;
}

export interface User extends UserInfoResponse {
  access?: MyRecord<string[]> | '*';
}

export interface UserCardResponse {
  province: string;
  is_official: boolean;
  user_id: string;
  name: string;
  avatar: string;
  username: string;
  username_a: string;
  groups_num: number;
  country: string;
  city: string;
  register_time: number;
}

export interface UserGroupRelationResponse {
  groups: {
    avatar: string;
    avatar_color: string;
    gid: string;
    group_name: string;
    member_num: number;
  }[];
}

export const enum UserKeyPackageType {
  SINGLE = 'single',
  GROUP = 'group',
}

export const enum UploadFileCategory {
  AVATAR = 'avatar',
}
export interface signResponse {
  data: string;
  chain_id: string;
}
export interface uploadFileParams {
  type?: string;
  name?: string;
  category?: UploadFileCategory;
  date_part?: number;
}

export interface uploadFileResponse {
  url: string;
  name: string;
  public_host: string;
  access_url: string;
}

export interface UserProfileParams {
  items: {
    cate: 'base' | 'extends' | 'shorts';
    data: Partial<UserProfileResponse['base' | 'extends' | 'shorts']>;
  }[];
}
export interface UserProfileResponse {
  user_id: string;
  base: {
    name: string;
    first_name: string;
    last_name: string;
    username: string;
    avatar: string;
    country: string;
    province: string;
    city: string;
    bio: string;
  };
  extends: {
    bg_urls: string[];
  };
  shorts: {
    follower_cnt: string;
  };
}

export interface CheckUserSubResponse {
  user_id: string;
  trace_id: string;
}

export interface RefreshGoogleResponse {
  token: string;
  token_type: string;
  refresh_token: string;
  expire: number;
}

export interface uploadDeviceParams {
  device_id: string;
  device_type: number;
  first_after_login: boolean;
  push_token: string;
  ios_voip_token: string;
  app_version: string;
  os_version: string;
  device_name: string;
}

export const enum StorageType {
  SESSION = 'session',
  LOCAL = 'local',
}
